import { render, staticRenderFns } from "./recipe-cna-submit.vue?vue&type=template&id=63314823&scoped=true&"
import script from "./recipe-cna-submit.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-submit.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-submit.vue?vue&type=style&index=0&id=63314823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63314823",
  null
  
)

export default component.exports